import React, { Component } from "react";
import "./OptSearch.css";
import $ from "jquery";

export default class OptSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dynamicId: "",
      hasFilters: false,
    };
  }

  checkActiveFilters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    let active = false;
    const filterKeys = ["search", "id_tonation", "id_cast", "id_genere", "id_year", "id_recipient_dedication", "opus"];
    
    filterKeys.forEach(key => {
      if (urlParams.get(key)) {
        active = true;
      }
    });
    this.setState({ hasFilters: active });
  }

  submitOptForm = (needReload = false) => {
    let match = "{";
    const inputText = $("#search-text").val() || "";

    const OptSearchUrl = window.location.pathname;
    let params = {};

    $("p.selected").text(inputText);
    $("p.selected").attr("data-value", inputText);

    const searchValue = inputText.trim();
    if (searchValue) {
      params["search"] = searchValue;
    }

    let opusValue = $("#opus").val();
    if (opusValue && opusValue !== "null") {
      params["opus"] = opusValue;
    }

    $(".search-row")
      .not(".search-row-text")
      .each(function () {
        var title = $(this).children(".search-form__td-title").attr("value");
        var selectedLi = $(this).find("li.selected");
        var value = selectedLi.length ? selectedLi.attr("value") : null;

        if (title && value) {
          params[title] = value;
          match += `"${title}":"${value}", `;
          sessionStorage.setItem(title, value);
        }
      });

    let queryString = Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");

    let newUrl = queryString ? `${OptSearchUrl}?${queryString}` : OptSearchUrl;
    window.history.pushState(null, "", newUrl);

    this.checkActiveFilters();

    if (needReload) {
      window.location.reload();
    }
  };

  startType = (e) => {
    const inputText = e.target.value;
    this.setState({ dynamicId: inputText ? "opusdata" : "" });

    $("p.selected").text(inputText).attr("data-value", inputText);

    if (inputText) {
      sessionStorage.setItem("opus", inputText);
    } else {
      sessionStorage.removeItem("opus");
    }
    this.checkActiveFilters();
  };

  clear = (e) => {
    e.preventDefault();
    sessionStorage.clear();
    const baseUrl = window.location.pathname;
    window.history.pushState(null, "", baseUrl);
    this.setState({ hasFilters: false }, () => {
      window.location.reload();
    });
  };

  componentDidMount() {
    const currentPath = window.location.pathname;
    const urlParams = new URLSearchParams(window.location.search);

    sessionStorage.setItem("OptSearchUrl", currentPath);

    const searchText = String(urlParams.get("search") || "");
    const tonation = String(urlParams.get("id_tonation") || "");
    const cast = String(urlParams.get("id_cast") || "");
    const genere = String(urlParams.get("id_genere") || "");
    const opus = String(urlParams.get("opus") || "");
    const year = String(urlParams.get("id_year") || "");
    const recipientDedication = String(urlParams.get("id_recipient_dedication") || "");

    let setReload = true;
    let optSearchObj = {};

    if (searchText) {
      sessionStorage.setItem("search", searchText);
      optSearchObj["search"] = searchText;
    }
    if (tonation) {
      sessionStorage.setItem("id_tonation", tonation);
      optSearchObj["id_tonation"] = tonation;
    }
    if (cast) {
      sessionStorage.setItem("id_cast", cast);
      optSearchObj["id_cast"] = cast;
    }
    if (genere) {
      sessionStorage.setItem("id_genere", genere);
      optSearchObj["id_genere"] = genere;
    }
    if (year) {
      sessionStorage.setItem("id_year", year);
      optSearchObj["id_year"] = year;
    }
    if (recipientDedication) {
      sessionStorage.setItem("id_recipient_dedication", recipientDedication);
      optSearchObj["id_recipient_dedication"] = recipientDedication;
    }
    if (opus && opus !== "null") {
      sessionStorage.setItem("opus", opus);
      optSearchObj["opus"] = opus;
    }

    sessionStorage.setItem("OptSearch", JSON.stringify(optSearchObj));

    this.loadFiltersFromSessionStorage();
    this.checkActiveFilters();

    if (!sessionStorage.getItem("submitFormCalled") && setReload) {
      this.submitOptForm();
      sessionStorage.setItem("submitFormCalled", "true");
    } else {
      const storedTonation = sessionStorage.getItem("id_tonation");
      const storedCast = sessionStorage.getItem("id_cast");
      const storedGenere = sessionStorage.getItem("id_genere");
      const storedYear = sessionStorage.getItem("id_year");
      const storedRecipient = sessionStorage.getItem("id_recipient_dedication");
      const storedOpus = sessionStorage.getItem("opus");

      if (
        tonation === storedTonation &&
        cast === storedCast &&
        genere === storedGenere &&
        year === storedYear &&
        recipientDedication === storedRecipient &&
        opus === storedOpus
      ) {
        setReload = false;
        sessionStorage.removeItem("submitFormCalled");
      }
    }

    if (opus === "null" || !opus) {
      $("#opus").val("");
    } else {
      $("#opus").val(opus);
    }
  }

  loadFiltersFromSessionStorage() {
    let searchText = sessionStorage.getItem("search");
    let tonation = sessionStorage.getItem("id_tonation");
    let cast = sessionStorage.getItem("id_cast");
    let genere = sessionStorage.getItem("id_genere");
    let year = sessionStorage.getItem("id_year");
    let recipientDedication = sessionStorage.getItem("id_recipient_dedication");
    let opus = sessionStorage.getItem("opus");

    const urlParams = new URLSearchParams(window.location.search);
    const searchTextUrl = urlParams.get("search");
    const tonationUrl = urlParams.get("id_tonation");
    const castUrl = urlParams.get("id_cast");
    const yearUrl = urlParams.get("id_year");
    const genereUrl = urlParams.get("id_genere");
    const recipientDedicationUrl = urlParams.get("id_recipient_dedication");
    const opusUrl = urlParams.get("opus");

    if (searchText != null && searchText === searchTextUrl) {
      $("#search-text").val(searchText);
      $("p.selected").text(searchText);
      $("p.selected").attr("data-value", searchText);
    }

    const applySelection = (selector, value) => {
      if (value != null && value !== "") {
        $(`${selector} li`).removeClass("selected");
        $(`${selector} li`).each(function () {
          if ($(this).attr("value") === value) {
            $(this).addClass("selected");
          }
        });
      }
    };

    applySelection("#tonation", tonation);
    applySelection("#cast", cast);
    applySelection("#genere", genere);
    applySelection("#year", year);
    applySelection("#recipient_dedication", recipientDedication);

    if (opus !== null && opus !== "null") {
      $("#opus").val(opus);
    } else {
      $("#opus").val("");
    }
  }

  render() {
    const self = this;

    document.addEventListener("keypress", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("search-engine-submit").click();
      }
    });

    $(function () {
      $(".select-container ul")
        .unbind()
        .click(function () {
          $(this).toggleClass("opened");
        });

      $("#optional-search-form ul li").unbind().click(function () {
        if ($(this).hasClass("selected")) {

        } else {
          $(this).addClass("selected").siblings().removeClass("selected");

          const parentId = $(this).parent("ul").attr("id");
          const itemValue = $(this).attr("value");
          
          if (itemValue === "") {
            sessionStorage.removeItem(`id_${parentId}`);
          } else {
            sessionStorage.setItem(`id_${parentId}`, itemValue);
          }
        }
        self.checkActiveFilters();
      });

      $("#search-text").unbind().on("input", function (e) {
        var inputText = $("#search-text").val();
        $("p.selected").text(inputText);
        self.checkActiveFilters();
      });
    });

    $(document).mouseup(function (e) {
      var container = $(".select-container ul.opened");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass("opened");
      }
    });

    let search_label_1 =
      window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
    let search_label_2 =
      window.location.href.indexOf("/en/") > -1
        ? "Enter a search phrase"
        : "Wpisz szukaną frazę";
    let search_label_3 =
      window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
    let search_label_4 =
      window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
    let search_label_5 =
      window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

    return (
      <div className="optional-search-container">
        <form id="optional-search-form" className="OptSearch">
          <table>
            <tbody>
              <tr className="search-row">
                <td
                  colSpan={2}
                  className="search-row-text search-form__td-title"
                  value="search"
                >
                  <input
                    id="search-text"
                    type="text"
                    placeholder={search_label_2}
                    aria-label="search text"
                  />
                  <p className="selected" style={{ margin: 0 }}></p>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[0].field_name}
                  >
                    {this.props.filter_search[0].name}
                  </span>
                  <div className="select-container">
                    <ul id="tonation">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[0].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[1].field_name}
                  >
                    {this.props.filter_search[1].name}
                  </span>
                  <div className="select-container">
                    <ul id="genere">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[1].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[2].field_name}
                  >
                    {this.props.filter_search[2].name}
                  </span>
                  <div className="select-container">
                    <ul id="cast">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[2].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[3].field_name}
                  >
                    {this.props.filter_search[3].name}
                  </span>
                  <div className="select-container">
                    <ul id="year">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[3].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[4].field_name}
                  >
                    {this.props.filter_search[4].name}
                  </span>
                  <div className="select-container">
                    <input
                      onChange={this.startType}
                      id="opus"
                      list="opusdata"
                      type="text"
                      placeholder={search_label_5}
                      aria-label={search_label_5}
                    />
                    <datalist id={this.state.dynamicId}>
                      {this.props.filter_search[4].list.map(function (
                        item,
                        index
                      ) {
                        return (
                          <option key={index} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                    </datalist>
                  </div>
                </td>
                <td className="search-row">
                  <span
                    className="search-form__td-title"
                    value={this.props.filter_search[5].field_name}
                  >
                    {this.props.filter_search[5].name}
                  </span>
                  <div className="select-container">
                    <ul id="recipient_dedication">
                      <li className="selected" value="">
                        {search_label_4}
                      </li>
                      {this.props.filter_search[5].list.map(function (
                        item,
                        index
                      ) {
                        var name = item.name;
                        var id = item.id;
                        return (
                          <li key={index} value={id}>
                            {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="search-engine-options">
            <button
              className={this.state.hasFilters ? "submit" : ""}
              onClick={this.clear}
            >
              {search_label_1}
            </button>
            <button
              id="search-engine-submit"
              className="submit"
              onClick={(e) => {
                e.preventDefault();
                this.submitOptForm(true);
              }}
            >
              {search_label_3}
            </button>
          </div>
        </form>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch/index.jsx